import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { UUIDValidationSchema } from './uuid';
const StorySceneValidationSchema = z.object({
    id: z.string(),
    title: z.string().optional(),
    description: z.string().optional(),
    htmlContent: z.string().optional(),
    markdownContent: z.string().optional(),
    contentFormat: z.enum(['markdown', 'html']).optional(),
    audioUrl: z.string().optional(),
    imageUrl: z.string().optional(),
    coordinates: z
        .array(z.number())
        .length(2, 'Coordinates must be an array of two numbers'),
    zoom: z.number(),
    bearing: z.number().optional(),
    pitch: z.number().optional(),
    duration: z.number().optional(),
    autoProgress: z.boolean().optional(),
    autoProgressDelay: z.number().optional(),
    layerKeys: z.array(z.string()).optional()
});
const StoryValidationSchema = z.object({
    _id: z
        .string()
        .uuid()
        .default(() => uuidv4()),
    name: z.string(),
    workshopId: UUIDValidationSchema,
    // createdBy and the timestamps are set by the API from the session, never accepted from the client.
    scenes: z.array(StorySceneValidationSchema)
});
// Neither the owning workshop nor the author can be reassigned: authorization is checked against the stored story, so accepting them here would let an update move a story out of the workshop it was authorized against.
const UpdateStoryValidationSchema = z.object({
    _id: UUIDValidationSchema,
    name: z.string().optional(),
    scenes: z.array(StorySceneValidationSchema).optional()
});
export { StorySceneValidationSchema, StoryValidationSchema, UpdateStoryValidationSchema };
//# sourceMappingURL=story.js.map